import { useState } from "react";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import { alpha } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser } from "../../redux/selectors/userSelector";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../redux/store/store";
import { logOut } from "../../redux/actions/userActions";

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector(selectCurrentUser);
  const navigate = useNavigate();

  const [open, setOpen] = useState(null);

  const handleOpen = (event: any) => {
    event.stopPropagation();
    setOpen(event.currentTarget);
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    setOpen(null);
  };

  const handleLogOut = async () => {
    await dispatch(logOut()).unwrap();
    navigate("/circle/sign-in");
  };

  const handleNavigateDashboard = () => {
    navigate(`/user/${userData?._id}`);
  };

  const handleNavigateHome = () => {
    navigate("/");
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) =>
            open
              ? `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`
              : alpha(theme.palette.grey[500], 0.08),
        }}
      >
        <Avatar
          src={userData?.profileImage ?? ""}
          alt={userData?.firstName}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {userData?.firstName.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1,
            ml: 0.75,
            width: 200,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {`${userData?.firstName}${userData?.lastName}`}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {userData?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        {/* <MenuItem key="home" onClick={handleNavigateHome}>
          Home
        </MenuItem> */}

        <MenuItem key="dashboard" onClick={handleNavigateDashboard}>
          My Dashboard
        </MenuItem>

        <Divider sx={{ borderStyle: "dashed", m: 0 }} />

        <MenuItem
          disableRipple
          disableTouchRipple
          onClick={handleLogOut}
          sx={{ typography: "body2", color: "error.main", py: 1.5 }}
        >
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
